module.exports = __webpack_public_path__ + "img/market1.1e5845a3.jpg";